module.exports = __webpack_public_path__ + "static/media/app-icon.7187d710.jpg";